var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85932 8.80995C6.59898 8.5496 6.59898 8.12749 6.85932 7.86714C7.11967 7.60679 7.54178 7.60679 7.80213 7.86714L10.4688 10.5338C10.7291 10.7942 10.7291 11.2163 10.4688 11.4766C10.2085 11.737 9.78634 11.737 9.52599 11.4766L6.85932 8.80995Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.0026C0 7.57993 2.08934 9.66927 4.66667 9.66927C7.244 9.66927 9.33333 7.57993 9.33333 5.0026C9.33333 2.42528 7.244 0.335938 4.66667 0.335938C2.08934 0.335938 0 2.42528 0 5.0026ZM7.99967 5.00252C7.99967 6.84347 6.50729 8.33586 4.66634 8.33586C2.82539 8.33586 1.33301 6.84347 1.33301 5.00252C1.33301 3.16157 2.82539 1.66919 4.66634 1.66919C6.50729 1.66919 7.99967 3.16157 7.99967 5.00252Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.64fbee1326f46e9023a85a19a0ae59a5.svg";
export { ForwardRef as ReactComponent };